<template>
  <div class="belfixJobMessage">

    <div v-if="worker.lang === 'fr'">
<p>🚨 CLIENT BELFIX. 🚨
A TRAITER AVEC LE PLUS GRAND SOIN :
- Respecter l’heure et la date du rendez-vous
- Respecter les conditions tarifaires affichées
- Prévenir le client avant tout dépassement du tarif et obtenir son accord au préalable
- Ne pas sur-facturer les pièces et les heures supplémentaires
- Facturer uniquement 50€ si le travail n’est pas réalisable
- Envoyer les devis et attestations en priorité
Après chaque intervention, le client vous évalue en vous attribuant une note, ce qui a un impact sur la quantité
de missions que vous recevrez.
🚨 AUCUNE PLAINTE NE SERA TOLÉRÉE 🚨
</p>
    </div >
    <div v-else-if="worker.lang === 'nl'">
      <p>
🚨 BELFIX KLANT(smiley) 🚨
TE BEHANDELEN MET DE GROOTSTE ZORG:
- Respecteer de tijd en datum van de afspraak
- Respecteer de weergegeven prijsvoorwaarden
- Waarschuw de klant voor elke prijsoverschrijding en verkrijg zijn voorafgaande toestemming
- Factureer niet overbodig veel voor onderdelen en overuren
- Factuur slechts 50€ als het werk niet haalbaar is
- Stuur offertes en certificaten als prioriteit
De klant evalueert u na elke interventie door u een score toe te kennen. Dat heeft een impact heeft op het aantal
missies dat u krijgt.
🚨 GEEN ENKELE KLACHT WORDT GETOLEREERD 🚨
      </p>
    </div>

    <div v-else>
      <p>
🚨 BELFIX CLIENT 🚨s
TO BE TREATED WITH THE GREATEST CARE:
- Respect the time and date of the appointment
- Respect the displayed pricing conditions
- Warn the customer before any overrun of the tariff and obtain his prior agreement
- Don't overcharge for parts and overtime
- Invoice only 50€ if the work is not doable
- Send quotes and certificates as a priority
The client evaluates you by assigning you a score after each intervention, which has an impact on the quantity of
missions you will receive.
🚨 NO SINGLE COMPLAINT WILL BE TOLERATED 🚨
      </p>
    </div>

  </div>
</template>


<script>

export default {
  props: {
    worker: Object
  },
}
</script>

<style>
.belfixJobMessage div{
  background: #f8f8f8;
  padding: 4px;
  text-align: left;
  border: 1px solid #eaeaeb;
  margin: 4px 0;
}

.belfixJobMessage div p{
  font-family: Arial;
  white-space: pre-wrap;
}
</style>

